import { useId } from "react";
import "./materialTemplatePicker.css";

function TemplatePaper({ kind }) {
  return <span className={"material-template-art material-template-art-" + kind} aria-hidden="true">
    <span className="material-template-paper">
      <span className="material-template-paper-title" />
      <span className="material-template-paper-rule" />
      <span className="material-template-paper-lines" />
      <span className="material-template-paper-question"><i /><i /><i /></span>
      <span className="material-template-paper-figure" />
    </span>
    <span className="material-template-paper material-template-paper-back" />
  </span>;
}

export default function MaterialTemplatePicker({ choices, value, onChange, disabled = false, catalogState = "ready" }) {
  const detailId = useId();
  const selected = choices.find((choice) => choice.id === value) || choices[0];
  if (!selected) return null;
  const status = (choice) => catalogState !== "ready"
    ? catalogState === "error" ? "尚未連線" : "讀取中"
    : choice.available ? "可使用" : "尚未開放";
  return <section className="material-panel material-template-picker" aria-label="選擇教材模板">
    <div className="material-heading material-template-heading">
      <div><span className="material-template-eyebrow">01 · 教材模板</span><h3>這次要整理哪一種教材？</h3></div>
      <p>選擇對應版型，後續都在同一個工作區完成。</p>
    </div>
    <div className="material-template-options" role="group" aria-label="教材模板">
      {choices.map((choice, index) => <button type="button" key={choice.id}
        className={"material-template-card material-template-tone-" + choice.tone}
        disabled={disabled} aria-pressed={value === choice.id}
        aria-describedby={value === choice.id ? detailId : undefined}
        onClick={() => onChange(choice.id)}>
        <span className="material-template-card-top"><span>{String(index + 1).padStart(2, "0")} / {choice.category}</span>
          <span className={"material-template-badge" + (choice.available ? " material-template-badge-ready" : "")}>{status(choice)}</span>
        </span>
        <TemplatePaper kind={choice.id} />
        <span className="material-template-card-title"><strong>{choice.label}</strong><span className="material-template-check" aria-hidden="true">{value === choice.id ? "✓" : ""}</span></span>
        <span className="material-template-description">{choice.description}</span>
        <span className="material-template-tags">{choice.tags.map((tag) => <span key={tag}>{tag}</span>)}</span>
      </button>)}
    </div>
    <div id={detailId} className={"material-template-detail material-template-tone-" + selected.tone} aria-live="polite" aria-atomic="true">
      <div className="material-template-detail-copy"><strong>{selected.label}</strong>
        <p>{selected.detail}</p>
        <ol className="material-template-workflow">{selected.workflow.map((step, index) => <li key={step}><span>{index + 1}</span>{step}</li>)}</ol>
      </div>
      <div className="material-template-readiness">
        {catalogState !== "ready" ? <p>{catalogState === "error" ? "目前無法讀取服務狀態，請重新載入後再開始解析。" : "正在確認可用模板…"}</p>
          : selected.available ? <><span className="material-template-ready-dot" />已選擇，可以加入來源</>
            : <><span className="material-template-pending-label">此模板目前未開放</span><p>{selected.id === "general" ? "請選擇其他可使用的模板。" : "可先用一般版整理這份教材。"}</p>
              {selected.id !== "general" && <button type="button" disabled={disabled || !choices.find((choice) => choice.id === "general")?.available} onClick={() => onChange("general")}>改用一般版</button>}</>}
      </div>
    </div>
  </section>;
}
